import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IOfficeHours } from 'app/models/licenses/office-hours';

@Injectable({providedIn: 'root'})
export class OfficeHoursService {

  public api: string = environment.privateApi + 'OfficeHours/';
  public http = inject(HttpClient);

  public getOfficeHours(entityId: number, entityType: string): Observable<IOfficeHours> {
    return this.http.get<IOfficeHours>(this.api + 'GetOfficeHours/' + entityId + '/' + entityType);
  }

  public createOfficeHours(officeHours: IOfficeHours, entityId: number, entityType: string): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'CreateOfficeHours/' + entityId + '/' + entityType, officeHours);
  }

  public updateOfficeHours(officeHours: IOfficeHours): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateOfficeHours', officeHours);
  }
}
